import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Draggable } from 'react-beautiful-dnd';



function ScheduleEdit({ dragHandleProps }) {

  const { t } = useTranslation();

  const apiUrl = process.env.REACT_APP_BACKEND_URL


  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let LanguageSelected = Cookies.get('LanguageSelected');

  const [ScheduleModal, setScheduleModal] = useState(false)
  const [EditScheduleModal, setEditScheduleModal] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])
  const [scheduleInfo, setScheduleInfo] = useState({})
  const [Done, setDone] = useState(false)
  const [ScheduleId, setScheduleId] = useState()
  const [isFetching, setIsFetching] = useState(false);
  const [scheduleContent, setScheduleContent] = useState([])

  const SetScheduleToUpdateDefaultValues = (id) => {
    const schedule = scheduleContent.find(item => item.id === id)
    return setScheduleInfo({ ...scheduleInfo, ScheduleId: schedule.id, name: schedule.name, end_time: schedule.end_time, start_time: schedule.start_time })
  }

  const AddingScheduleInfo = (e) => {
    return setScheduleInfo({ ...scheduleInfo, [e.target.name]: e.target.value })
  }

  useEffect(() => {
    if (ScheduleModal || EditScheduleModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [ScheduleModal, EditScheduleModal]);


  useEffect(() => {
    fetch(`${apiUrl}/GetScheduleInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setScheduleContent(result.data)

        }
      })
  }, [Done])

  const StoreScheduleInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/StoreScheduleInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(scheduleInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setScheduleInfo('')
          setDone(!Done)
          setInputsErrors([])
          setScheduleModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });


  }

  const UpdateScheduleInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/UpdateScheduleInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(scheduleInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setScheduleInfo('')
          setInputsErrors([])
          setDone(!Done)
          setEditScheduleModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const DeleteScheduleInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteSchedule`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ scheduleId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }

  const Days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const existingDays = scheduleContent.map(item => item.name);
  
  const uniqueDays = Days.filter(day => !existingDays.includes(day));

  
  scheduleContent.sort((a, b) => {
    return Days.indexOf(a.name) - Days.indexOf(b.name);
  });
  
  



  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>

      <section className="About sections rounded-xl pt-3 pb-3 pl-3 m-3">
        <div className='flex justify-between'>
          <div>
            <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t('Horaire Travail S')}</h1>
          </div>
          </div>

          <div className="pl-4 pr-4 w-full ">
            <div className="grid grid-cols-1 gap-4">
              <div className="col-span-12 sm:col-span-6 md:col-span-3">

                {scheduleContent != '' &&

                  scheduleContent.map(item => {
                    return (
                      <>
                        <div className="relative flex flex-row div-sections rounded p-1 mt-4 mr-1" key={item.id}>
                          <div className=" flex  flex-col review-ite flex-none w-full md:w-1/2 lg:w-1/3 ">
                            <div className="flex flex-col -pb-2">
                              <div className="flex justify-start  gap-6 items-center px-2 py-2 ">
                                <div className='flex justify-start items-center gap-2'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-clock"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h5"/><path d="M17.5 17.5 16 16.25V14"/><path d="M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"/></svg>                                <p className='text-lg font-semibold '>
                                  {t(`${item.name}`)}
                                </p>
                                </div>

                                  <p className='text-lg font-normal '>
                                    {item.start_time} - {item.end_time}
                                  </p>
                              </div>
                            </div>
                          </div>


                          <div className={`${LanguageSelected == 'ar' ? 'flex items-center absolute left-6 top-4 ' : 'flex items-center absolute top-6  -right-4  '}`}>

                            <svg onClick={() => { setEditScheduleModal(true); SetScheduleToUpdateDefaultValues(item.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 cursor-pointer">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                            </svg>
                            <svg onClick={(e) => { DeleteScheduleInfo(e, item.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5 cursor-pointer' : 'w-6 mr-5 cursor-pointer' }`}>
                              <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                            </svg>
                          </div>
                        </div>

                      </>



                    )
                  })}
              </div>
            </div>
          </div>




        <a onClick={() => { setScheduleModal(true) }}>
          <main className="flex p-5  items-center justify-center  ">
            <label htmlFor="dropzone-file-schedule" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded-xl border-2 border-dashed border-gold div-sections p-6 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 ">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="mt-2 text-about tracking-wide">{t("Entrez vos informations 'Horaire Travail'.")}</p>
            </label>
          </main>
        </a>



        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
          </svg>

        </div>

      </section>

      {ScheduleModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setScheduleModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl mb-2 text-theme ">{t('Horaire Travail')}</h2>
              <form className="space-y-6 text-schedule">
                <div>
                  <label htmlFor="phoneNumber" className="textModal  ">{t("Veuillez saisir les informations sur votre horaire de travail.")}</label>
                  <div className="mt-5">
                    <select onChange={(e) => AddingScheduleInfo(e)} type="text" id="email" name="name" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Day")} required >
                      <option selected disabled>{t('Day')}</option>
                    {
                        uniqueDays.map(day => {
                          return(
                            <option value={day}>{t(`${day}`)}</option>
                          )
                        })
                      }
                    </select>
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span></p>

                    <input onChange={(e) => AddingScheduleInfo(e)} type="time" id="email" name="start_time" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('start_time') && InputsErrors.start_time}</span></p>


                    <input onChange={(e) => AddingScheduleInfo(e)} type="time" id="email" name="end_time" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('end_time') && InputsErrors.end_time}</span></p>


                  </div>
                </div>
                <button onClick={(e) => StoreScheduleInfo(e)} disabled={isFetching} type="submit" className={`w-full  btn-edit`}>
                  {t('enregistrer')}
                </button>
              </form></div>
          </div>
        </div>


      }

      {EditScheduleModal &&

        <div>

          <div className="forms-info minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50  ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setEditScheduleModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl mb-2 text-theme ">{t("Modifier les informations  'Horaire Travail'")}</h2>
              <form className="space-y-6 text-schedule">
                <div>
                  <label htmlFor="phoneNumber" className="textModal text-black ">{t("Veuillez saisir les informations sur votre horaire de travail.")}</label>
                  <div className="mt-5">
                    <select defaultValue={scheduleInfo.name} onChange={(e) => AddingScheduleInfo(e)} type="text" id="email" name="name" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("")} required >
                      {
                        uniqueDays.map(day => {
                          return(
                            <option value={day}>{t(`${day}`)}</option>
                          )
                        })
                      }
                    </select>
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span></p>

                    <input defaultValue={scheduleInfo.start_time} onChange={(e) => AddingScheduleInfo(e)} type="time" id="email" name="start_time" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre lien de  Calendly")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('start_time') && InputsErrors.start_time}</span></p>


                    <input defaultValue={scheduleInfo.end_time} onChange={(e) => AddingScheduleInfo(e)} type="time" id="email" name="end_time" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre lien de  Calendly")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('end_time') && InputsErrors.end_time}</span></p>

                  </div>
                </div>
                <button onClick={(e) => UpdateScheduleInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                  {t('enregistrer')}

                </button>
              </form></div>
          </div>
        </div>


      }


    </div>
  )
}

export default ScheduleEdit